import { render, staticRenderFns } from "./ETabelaParcelaPreMatricula.vue?vue&type=template&id=58c4fbdc"
import script from "./ETabelaParcelaPreMatricula.vue?vue&type=script&lang=js"
export * from "./ETabelaParcelaPreMatricula.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports